<template lang="pug">
.d-findUs
  .module1
    .title 懂窝线下体验店
      .border
    .line1 懂窝线下体验店根据加减乘除四大产品系列进行划分布置，每个空间都是一个个家的故事，<br>通过富有温度的场景打造，营造出沉浸式家居购物体验。
  .module2
    .swiper-container.d-swiper1
      .swiper-wrapper
          .swiper-slide
            img(src="~assets/findUs/swiper1-1.png")
          .swiper-slide
            img(src="~assets/findUs/swiper1-2.png")
          .swiper-slide
            img(src="~assets/findUs/swiper1-3.png")
          .swiper-slide
            img(src="~assets/findUs/swiper1-4.png")
      .swiper-pagination
      .swiper-button-prev
      .swiper-button-next
  .module3
    .title 线上购物渠道
      .border
    .line1 您不仅可以亲临懂窝体验店感受家的温度，<br>还可以通过懂窝天猫店或懂窝微信小程序等线上渠道，<br>轻松在线浏览懂窝产品，收获家居灵感及搭配方案，实现心目中家的样子。
  .module4
    .line1 一键购买心仪好物
    .line2 足不出户 体验便捷
    .code-box
      img(src="~assets/index/img17.png")
      p 扫码进入<br/> 懂窝天猫店
      img(src="~assets/index/img18.png")
      p 扫码进入<br/> 懂窝小程序
  .module5
    .title 软装搭配服务
      .border
    .line1 我们不仅提供设计、品质、性价比、功能和舒适度兼具的产品，<br/> 还可根据客户需求提供量身定制的软装设计服务，帮您实现心目中家的样子。
  .module6
    .line1 懂窝软装设计服务提供包含家具、床品/地毯、灯具、软装饰品、装饰画、墙面和窗帘等七项软装设计咨询及搭配服务。
    .line1 1.您可以与懂窝销售或客服联系，描绘您对家的期望与想象，我们将为您匹配专业设计师。<br/> 2.设计师将与您进行深度沟通，挖掘您的设计需求，确定大致的设计方向。<br/> 3并为您提供精心匹配的产品清单和量身定制的软装搭配方案，帮助您实现家的样子。
    .qr-code
      img(src="~assets/findUs/img6.png")
      p 扫码了解更多
    img.img(src="~assets/findUs/img5.png")
  .module7
    .title 客户设计案例
    .swiper-container.d-swiper2
      .swiper-wrapper
        .swiper-slide
          img(src="~assets/findUs/swiper2-1.jpg")
        //- .swiper-slide
        //-   img(src="~assets/findUs/swiper2-2.jpg")
        .swiper-slide
          img(src="~assets/findUs/swiper2-3.jpg")
        .swiper-slide
          img(src="~assets/findUs/swiper2-4.jpg")
        //- .swiper-slide
        //-   img(src="~assets/findUs/swiper2-5.jpg")
        .swiper-slide
          img(src="~assets/findUs/swiper2-6.jpg")
      .swiper-pagination
      .swiper-button-prev
      .swiper-button-next
  img.scroll-top-btn(v-show="scrollTop", @click="backtop", src="~assets/goTop.png")
</template>

<script>
export default {
  data() {
    return {
      scrollTop: false
    };
  },
  mounted() {
    this.$nextTick(()=>{
      var mySwiper = new Swiper(".d-swiper1", {
        paginationClickable: true,
        loop: true,
        speed: 500,
        autoplayDisableOnInteraction: false,
        nextButton: ".swiper-button-next",
        prevButton: ".swiper-button-prev",
        // // 如果需要分页器
        // pagination: ".swiper-pagination",
        effect: "slide",
        onInit: function(swiper) {
          // swiper加载完毕
        }
      });
      var mySwiper1 = new Swiper(".d-swiper2", {
        paginationClickable: true,
        loop: true,
        speed: 500,
        autoplayDisableOnInteraction: false,
        nextButton: ".swiper-button-next",
        prevButton: ".swiper-button-prev",
        // // 如果需要分页器
        // pagination: ".swiper-pagination",
        effect: "slide",
        onInit: function(swiper) {
          // swiper加载完毕
        }
      });
    })
    window.addEventListener("scroll", this.showbtn, true);
  },
  methods: {
    // 显示回到顶部按钮
    showbtn() {
      let that = this;
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      that.scrollTop = scrollTop;
    },
    /**
     * 回到顶部功能实现过程：
     * 1. 获取页面当前距离顶部的滚动距离（虽然IE不常用了，但还是需要考虑一下兼容性的）
     * 2. 计算出每次向上移动的距离，用负的滚动距离除以5，因为滚动的距离是一个正数，想向上移动就是做一个减法
     * 3. 用当前距离加上计算出的距离，然后赋值给当前距离，就可以达到向上移动的效果
     * 4. 最后记得在移动到顶部时，清除定时器
     */
    backtop() {
      var timer = setInterval(function() {
        let osTop =
          document.documentElement.scrollTop || document.body.scrollTop;
        let ispeed = Math.floor(-osTop / 5);
        document.documentElement.scrollTop = document.body.scrollTop =
          osTop + ispeed;
        if (osTop === 0) {
          clearInterval(timer);
        }
      }, 30);
    }
  }
};
</script>

<style lang="sass" scoped>
@import 'config'
.d-findUs
  width: 100%
  .module1
    width: 100%
    height: r(855)
    padding-top: r(298)
    background: url('~assets/findUs/img1.png') no-repeat center / cover
    .title
      width: 100%
      font-family: PingFangSC-Medium
      font-size: r(40)
      color: #FEFFFF
      text-align: center
      .border
        margin: r(40) auto 0
        width: r(42)
        height: r(4)
        background: #ffffff
    .line1
      margin-top: r(54)
      width: 100%
      font-family: PingFangSC-Medium
      font-size: r(25)
      color: #FEFFFF
      text-align: center
      line-height: r(42)
  .module2
    margin: r(176) auto 0
    width: r(1300)
    .swiper-container
      width: 100%
      .swiper-wrapper
        width: 100%
        .swiper-slide
          width: 100% !important
          img
            display: block
            margin: 0 auto
            width: r(1120)
      .swiper-button-prev
        width: r(24)
        height: r(45)
        background-image: url('~assets/icon-left.png')
        background-size: cover
      .swiper-button-next
        width: r(24)
        height: r(45)
        background-image: url('~assets/icon-right.png')
        background-size: cover
  .module3
    margin-top: r(181)
    width: 100%
    height: r(855)
    padding-top: r(303)
    background: url('~assets/findUs/img2.png') no-repeat center / cover
    .title
      width: 100%
      font-family: PingFangSC-Medium
      font-size: r(40)
      color: #FEFFFF
      text-align: center
      .border
        margin: r(40) auto 0
        width: r(42)
        height: r(4)
        background: #ffffff
    .line1
      margin-top: r(54)
      width: 100%
      font-family: PingFangSC-Medium
      font-size: r(25)
      color: #FEFFFF
      text-align: center
      line-height: r(42)
  .module4
    margin: r(187) auto 0
    width: r(1024)
    height: r(564)
    background: url('~assets/findUs/img3.png') no-repeat center / cover
    padding-top: 0.1px
    .line1
      margin: r(57) 0 0 r(95)
      font-family: PingFangSC-Semibold
      font-size: r(40)
      color: #FEFFFF
    .line2
      margin: r(10) 0 0 r(95)
      font-family: PingFangSC-Semibold
      font-size: r(24)
      color: #FEFFFF
    .code-box
      margin: r(272) 0 0 r(98)
      display: flex
      align-items: flex-end
      img
        width: r(94)
        // &:nth-child(3)
        //   width: r(110)
      p
        margin-left: r(16)
        margin-right: r(10)
        font-family: PingFangSC-Semibold
        font-size: r(18)
        color: #FEFFFF
  .module5
    margin-top: r(186)
    width: 100%
    height: r(855)
    padding-top: r(303)
    background: url('~assets/findUs/img4.png') no-repeat center / cover
    .title
      width: 100%
      font-family: PingFangSC-Medium
      font-size: r(40)
      color: #FEFFFF
      text-align: center
      .border
        margin: r(40) auto 0
        width: r(42)
        height: r(4)
        background: #ffffff
    .line1
      margin-top: r(54)
      width: 100%
      font-family: PingFangSC-Medium
      font-size: r(25)
      color: #FEFFFF
      text-align: center
      line-height: r(42)
  .module6
    margin: r(142) auto 0
    width: r(1018)
    .line1
      width: r(812)
      margin: 0 auto r(40)
      font-family: PingFangSC-Medium
      font-size: r(20)
      color: #000000
      line-height: r(39)
    .qr-code
      margin: r(88) auto 0
      width: r(120)
      img
        margin: 0 auto
        display: block
        width: r(120)
      p
        margin-top: r(20)
        font-family: PingFangSC-Medium
        font-size: r(20)
        color: #000000
    .img
      margin-top: r(88)
      width: r(1018)
  .module7
    margin: r(156) auto r(400)
    width: r(1300)
    .title
      margin-bottom: r(74)
      font-family: PingFangSC-Semibold
      font-size: r(30)
      color: #000000
      text-align: center
    .swiper-container
      width: 100%
      .swiper-wrapper
        width: 100%
        .swiper-slide
          width: 100% !important
          img
            display: block
            margin: 0 auto
            width: r(1120)
      .swiper-button-prev
        width: r(24)
        height: r(45)
        background-image: url('~assets/icon-left.png')
        background-size: cover
      .swiper-button-next
        width: r(24)
        height: r(45)
        background-image: url('~assets/icon-right.png')
        background-size: cover
  .scroll-top-btn
    position: fixed
    z-index: 100
    bottom: r(100)
    right: r(100)
    width: r(80)

</style>



// WEBPACK FOOTER //
// findUs.vue?4434c213